import { ScoopText, ScoopCenter, ScoopColumn } from '../../../../ui'
import { TreeStructureIcon } from '@phosphor-icons/react'
import styles from './ProcessNoDataInput.module.scss'

export const ProcessNoDataInput = () => {
    return (
        <ScoopCenter className={styles.container}>
            <ScoopColumn className={styles.content}>
                <TreeStructureIcon size={48} weight="duotone" className={styles.icon} />
                <ScoopText className={styles.message}>
                    Create a new Diagram by selecting attributes on the left side panel
                </ScoopText>
            </ScoopColumn>
        </ScoopCenter>
    )
}
